import { Observable } from 'rxjs';
import { JapiQuery, PadAgreement, ResponseFromServer } from '../../shared/_models/models';
import { FusionApiHttpClient } from '../../shared/_services/server-clients';

export class SupplyPadAgreementApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  getPadAgreements(query: JapiQuery): Observable<ResponseFromServer<PadAgreement[]>> {
    return this.fusionApiHttpClient.post<PadAgreement[], JapiQuery>('padAgreement/get', query);
  }

  getPadAgreementById(paId: number): Observable<ResponseFromServer<PadAgreement>> {
    return this.fusionApiHttpClient.get<PadAgreement>(`padAgreement/${paId}`);
  }

  createPadAgreement(padAgreement: PadAgreement): Observable<ResponseFromServer<PadAgreement>> {
    return this.fusionApiHttpClient.post<PadAgreement, PadAgreement>('padAgreement/', padAgreement);
  }

  updatePadAgreement(paId: number, padAgreement: PadAgreement): Observable<ResponseFromServer<PadAgreement>> {
    return this.fusionApiHttpClient.put<PadAgreement, PadAgreement>(`padAgreement/${paId}`, padAgreement);
  }
}
